export default {
	namespaced: true,

	state: {
		contacts: null
	},

	mutations: {
		set(state, data) {
			state.contacts = data;
		}
	},

	getters: {
		getContacts(state) {
			return state.contacts;
		}
	},

	actions: {
		async add(context, options) {
			context.commit('set', options);
		}
	}
};